import classNames from "classnames";

import {MatchMode} from "@/components/filterDropdown/FilterDropdown.ts";
import {ToggleButton} from "@/components/toggleButton/ToggleButton.tsx";
import {ToggleButtonVariant} from "@/components/toggleButton/ToggleButton.types.ts";

interface MatchModeToggleProps {
  value: MatchMode;
  onChange: (mode: MatchMode) => void;
  variant?: ToggleButtonVariant;
  className?: string;
}

export const MatchModeToggle = ({value, onChange, variant = "segmented", className}: MatchModeToggleProps) => (
  <div className={classNames("d-flex align-items-center gap-2", className)}>
    <span className="pulseTextBodySmall pulse-color-gray-600">Match:</span>
    <ToggleButton
      variant={variant}
      items={[
        {id: "OR", label: "Any Tag"},
        {id: "AND", label: "All Tags"},
      ]}
      selectedId={value}
      onChange={(id) => onChange(id as MatchMode)}
    />
  </div>
);
